import { FilterCheck, FilterCross, FilterPlus } from '@components/icons'
import { AnimatePresence } from 'motion/react'
import { useState } from 'react'

interface Props {
  selected: boolean
}
const Selector = ({ selected }: Props) => {
  const [hover, setHover] = useState(false)
  return (
    <AnimatePresence>
      {selected ? (
        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-white transition-all duration-300"
        >
          {hover ? <FilterCross /> : <FilterCheck />}
        </div>
      ) : (
        <div className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-white bg-opacity-50 transition-all duration-300 hover:bg-opacity-100">
          <FilterPlus />
        </div>
      )}
    </AnimatePresence>
  )
}
export default Selector
